import vmClient from '../../services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from '../../types/entity';
import { ITextTranslation, TextTranslation } from './TextTranslation';

export interface IText extends IEntity {
  attributes: {
    formatted: boolean;
    id: EntityStringId;
    text: string;
  };
  associations: {
    textTranslations: ITextTranslation[];
  };
}

export type Text = Entity<IText>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Text: IEntityType<IText> = vmClient.defineClass({
  typeName: 'Text',
  version: 1,
  lockable: true,
  persisted: true,

  attributes: {
    formatted: {
      type: 'boolean',
      notNull: true,
    },
    text: {
      type: 'string',
      notNull: true,
    },
  },
  associations: {
    textTranslations: {
      collection: true,
      type: TextTranslation,
      notNull: true,
    },
  },
});
